export default {
    // Название формы для отправки ссылки
    markingForm: {
        // Поля формы
        fields: {
            // Бек не возвращает поле ошибки
            // link: {
            //     422010: 'CREATIVE_LINK_NOT_VALID_ERROR',
            //     422016: 'CREATIVE_LINK_ERROR',
            //     422042: 'CREATIVE_LINK_MAX_LENGTH',
            // },
            // description: {
            //     422022: 'CREATIVE_DESCRIPTION_REQUIRED_ERROR',
            //     422032: 'CREATIVE_DESCRIPTION_MAX_LENGTH_ERROR',
            //     422011: 'CREATIVE_DESCRIPTION_ERROR',
            // },
            // type: {
            //     422014: 'CREATIVE_OFFER_ID_REQUIRED_ERROR',
            //     422015: 'CREATIVE_OFFER_ID_NUMBER_ERROR',
            // },
            // offerId: {
            //     422014: 'CREATIVE_OFFER_ID_REQUIRED_ERROR',
            //     422015: 'CREATIVE_OFFER_ID_NUMBER_ERROR',
            // },
            // ordForm: {
            //     422041: 'CREATIVE_ORD_FORM_INVALID',
            // },
            // ordText: {
            //     422035: 'CREATIVE_ORD_TEXT_REQUIRED',
            //     422036: 'CREATIVE_ORD_TEXT_INVALID',
            // },
            // ordRim: {
            //     422037: 'CREATIVE_ORD_RIM_REQUIRED',
            //     422038: 'CREATIVE_ORD_RIM_INVALID',
            // },
            // ordDescription: {
            //     422039: 'CREATIVE_ORD_DESCRIPTION_REQUIRED',
            // },
        },
        422039: 'MARKING_FORM_ORD_DESCRIPTION_ERROR',
        422037: 'MARKING_FORM_RIM_ERROR',
        422038: 'MARKING_FORM_RIM_ERROR',
        422035: 'CREATIVE_UNKNOWN_ERROR',
        422036: 'CREATIVE_UNKNOWN_ERROR',
        422041: 'CREATIVE_UNKNOWN_ERROR',
        422014: 'CREATIVE_UNKNOWN_ERROR',
        422015: 'CREATIVE_UNKNOWN_ERROR',
        422022: 'MARKING_FORM_DESCRIPTION_ERROR',
        422032: 'MARKING_FORM_DESCRIPTION_ERROR',
        422011: 'MARKING_FORM_DESCRIPTION_ERROR',
        422010: 'MARKING_FORM_LINK_ERROR',
        422016: 'MARKING_FORM_LINK_ERROR',
        422042: 'MARKING_FORM_LINK_ERROR',
        // Дефолтный текст формы
        default: 'CREATIVE_UNKNOWN_ERROR',
    },
};
